module.exports = __webpack_public_path__ + "static/img/pallet.a10b00a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pallet.jpg
// module id = 0sWW
// module chunks = 1